import {authenticated_api, unauthenticated_api} from "./base";

export const userInvite = async (email) => {
  try {
    return await authenticated_api.post("/admin/invite_user/",
      {email: email}
    );
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const userSignup = async (userdata) => {
  try {
    const config = {headers: {"Content-Type": "application/json"}};
    return await unauthenticated_api.post(`/user/signup/`, userdata, config);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const adminSignup = async (admindata) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json"}
    };
    return await authenticated_api.post(
      `/admin/signup_admin/`,
      admindata,
      config
    );
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const validateInviteCode = async (code) => {
  try {
    return await authenticated_api.post(
      `/admin/validate_invite_code/`,
      {invite_code: code},
      {headers: {"Content-Type": "application/json"}});
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const setTemporaryPassword = async (payload) => {
  try {
    return await authenticated_api.post("/admin/set_temporary_password/",
      payload
    );
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const getQuotaDashboard = async () => {
  try {
    return await authenticated_api.get("/admin/metrics/quota-dashboard/");
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

const getAdminMetrics = async (path, since) => {
  try {
    return await authenticated_api.get(path, { params: since ? { since } : {} });
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

/** Admin Overview: new users and stored activity events. */
export const getActivityMetrics = (since) => getAdminMetrics("/admin/metrics/activity/", since);
/** Admin Overview: enrichment volume and usage. */
export const getClevelMetrics = (since) => getAdminMetrics("/admin/metrics/clevel/", since);
/** Admin Overview: failures and operation latency. */
export const getEngineeringMetrics = (since) => getAdminMetrics("/admin/metrics/engineering/", since);

export const listAdminStories = async () => {
  try {
    return await authenticated_api.get("/admin/stories/");
  } catch (error) {
    if (process.env.NODE_ENV !== "production") console.log(error);
    return error.response;
  }
};

export const previewAdminStory = async (payload) => {
  try {
    return await authenticated_api.post("/admin/stories/preview/", payload);
  } catch (error) {
    if (process.env.NODE_ENV !== "production") console.log(error);
    return error.response;
  }
};

export const createAdminStory = async (payload) => {
  try {
    return await authenticated_api.post("/admin/stories/", payload);
  } catch (error) {
    if (process.env.NODE_ENV !== "production") console.log(error);
    return error.response;
  }
};

export const updateAdminStory = async (storyId, payload) => {
  try {
    return await authenticated_api.put(`/admin/stories/${storyId}`, payload);
  } catch (error) {
    if (process.env.NODE_ENV !== "production") console.log(error);
    return error.response;
  }
};

export const publishAdminStory = async (storyId, payload) => {
  try {
    return await authenticated_api.post(
      `/admin/stories/${storyId}/publish/`,
      payload
    );
  } catch (error) {
    if (process.env.NODE_ENV !== "production") console.log(error);
    return error.response;
  }
};

export const unpublishAdminStory = async (storyId) => {
  try {
    return await authenticated_api.delete(`/admin/stories/${storyId}`);
  } catch (error) {
    if (process.env.NODE_ENV !== "production") console.log(error);
    return error.response;
  }
};
